var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckmark = function SvgCheckmark(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C6EAE4",
    d: "M27.201 46.83l35.844-35.843A9.5 9.5 0 1 1 76.48 24.422L32.823 68.079a9.493 9.493 0 0 1-2.876 2.555 9.524 9.524 0 0 1-13.01-3.486L.961 39.476a9.524 9.524 0 0 1 16.496-9.524L27.2 46.83z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.242,
    cy: 34.962,
    fill: "#8ED6C9",
    rx: 9.563,
    ry: 9.524,
    transform: "rotate(-120 9.242 34.962)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjQzZFQUU0IiBkPSJNMjcuMjAxIDQ2LjgzbDM1Ljg0NC0zNS44NDNBOS41IDkuNSAwIDEgMSA3Ni40OCAyNC40MjJMMzIuODIzIDY4LjA3OWE5LjQ5MyA5LjQ5MyAwIDAgMS0yLjg3NiAyLjU1NSA5LjUyNCA5LjUyNCAwIDAgMS0xMy4wMS0zLjQ4NkwuOTYxIDM5LjQ3NmE5LjUyNCA5LjUyNCAwIDAgMSAxNi40OTYtOS41MjRMMjcuMiA0Ni44M3oiLz48ZWxsaXBzZSBjeD0iOS4yNDIiIGN5PSIzNC45NjIiIGZpbGw9IiM4RUQ2QzkiIHJ4PSI5LjU2MyIgcnk9IjkuNTI0IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTIwIDkuMjQyIDM0Ljk2MikiLz48L2c+PC9zdmc+";